import { combineReducers } from 'redux';
import user from './userReducer';
import setting from "./settingReducer";
import price from "./priceReducer";
import ticket from "./ticketReducer";
import search from "./searchReducer";
import airports from "./airportsReducer";
import selectedairports from './selectedairports';
import busSearch from './BusSearchReducer';
import busticket from './BusticketReduser';
import bususer from "./BusUserRedeucer"
import busissue from "./BusIssueReducer"

export default combineReducers({
    user,
    setting,
    price,
    ticket,
    search,
    airports,
    selectedairports,
    busSearch,
    busticket,
    bususer,
    busissue
});




// WEBPACK FOOTER //
// ./src/redux/reducers/index.js